import ReceivedAtDate from '../../../components/ReceivedAtDate';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import _ from 'lodash';

import { TextInput } from '../../../components/PageHeader/TextInput';
import { DATE_TIME_SPACE_12_UPPERCASE } from '../../../constants';
import Table, { Column } from '../../../containers/Table/TableWithPagination';
import Strings from '../../../Strings';
import { getVitalsData, getVitalsDate } from '../../../utils';
import './patient.scss';
import { actions } from './redux/actions';
import { getGlobalPageSize } from '../../../utils/tableUtils';

class PatientEvent extends PureComponent {
  searchTime;

  componentDidMount() {
    this.pageRequest = {
      offset: 0,
      search: '',
      limit: this.props.globalPageSize,
    };
    const { patientId } = this.props;
    this.props.getPatientEvent(this.pageRequest, patientId);
  }

  onSearchQueryChange = query => {
    this.pageRequest.offset = 0;
    this.pageRequest.search = query;
    clearTimeout(this.searchTime);
    const { patientId } = this.props;
    this.searchTime = setTimeout(() => {
      this.props.getPatientEvent(this.pageRequest, patientId);
    }, 1000);
  };

  getHeaderComponents = () => {
    return (
      <React.Fragment>
        <TextInput
          class="search"
          placeholder={Strings.search}
          onChange={e => this.onSearchQueryChange(e.target.value)}
        />
      </React.Fragment>
    );
  };

  onOffsetChange = (offset, limit) => {
    if (isNaN(offset)) return;
    this.pageRequest.offset = offset;
    if (limit) this.pageRequest.limit = limit;
    const { patientId } = this.props;
    this.props.getPatientEvent(this.pageRequest, patientId);
  }

  onSortClick = ({ sortKey, direction }) => {
    this.pageRequest.offset = 0;
    this.pageRequest.sortColumn = sortKey;
    this.pageRequest.sortType = direction;
    const { patientId } = this.props;
    this.props.getPatientEvent(this.pageRequest, patientId);
  };

  onEditTask = (event, task) => {
    event.preventDefault();
    event.stopPropagation();
    this.props.onEditTask(this.pageRequest, task, this.props.taskList);
  };

  onDeletePatientEvent = (event, patientEvent) => {
    event.preventDefault();
    event.stopPropagation();
    const { patientId } = this.props;

    const data = {
      title: (
        <span>
          {Strings.deleteTaksHistoryWarning} <b>{patientEvent.taskName}</b>?
        </span>
      ),

      onConfirmAction: actions.deletePatientEvent(patientId, patientEvent.id, [
        actions.getPatientEvent(this.pageRequest, patientId),
      ]),
      onCancelAction: null,
    };
    this.props.openConfirmModal(data);
  };

  render() {
    const { isLoading, pagination, patientEvents, patientDetails } = this.props;

    return (
      <div className="patient-container topPadding">
        {/* <PageHeader getHeaderComponents={() => this.getHeaderComponents()} /> */}
        <Table
          className="patient-task-history-table"
          isLoading={isLoading}
          name="organizations"
          data={patientEvents || []}
          onRowSelection={() => {}}
          onSortClick={this.onSortClick}
          onOffsetChange={this.onOffsetChange}
          pagination={
            pagination || {
              offset: 0,
              total: 0,
            }
          }
        >
          <Column key="deviceId1" title={Strings.capPatient.deviceId} value={d => d.deviceId} />
          <Column key="deviceType" title={Strings.deviceType} value={d => d.deviceType} />
          <Column
            key="timestamp"
            title={Strings.date}
            value={e => (
              <ReceivedAtDate measuredAt={getVitalsDate(e.vitals)} backendTimestamp={e.backend_timestamp}>
                {!_.isEmpty(e.vitals) ? moment(getVitalsDate(e.vitals)).format(DATE_TIME_SPACE_12_UPPERCASE) : '-'}
              </ReceivedAtDate>
            )}
          />
          <Column
            key="Data"
            title={Strings.capPatient.data}
            value={e => (!_.isEmpty(e.vitals) ? getVitalsData(e.vitals) : '-')}
          />
        </Table>
      </div>
    );
  }
}

PatientEvent.propTypes = {
  getPatientEvent: PropTypes.func,
  isLoading: PropTypes.any,
  onAddSchedule: PropTypes.any,
  onEditTask: PropTypes.func,
  openConfirmModal: PropTypes.func,
  pagination: PropTypes.shape({
    offset: PropTypes.number,
    total: PropTypes.number,
  }),
  patientDetails: PropTypes.any,
  patientEvents: PropTypes.array,
  patientId: PropTypes.any,
  taskList: PropTypes.any,
};

const mapStateToProps = state => {
  const { patients } = state.superUser;
  return {
    patientEvents: patients?.patientEvents?.data,
    pagination: patients?.patientEvents?.pagination,
    isLoading: patients?.isPatientEventsLoading,
    globalPageSize: getGlobalPageSize(state),
  };
};

const mapDispatchToProps = dispatch => ({
  onNavigate: path => dispatch(push(path)),
  getPatientEvent: (pageRequest, patientId) => dispatch(actions.getPatientEvent(pageRequest, patientId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PatientEvent);
